import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { UserService } from 'src/app/services/user.service';

import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { PayeeService } from 'src/app/services/payee.service';

import { TaggingService } from 'src/app/tags/tagging.service';

import { AddressValidationService } from 'src/app/services/address-validation.service';
 
@Component({

  selector: 'upsc-flex-address-validator',

  templateUrl: './flex-address-validator.component.html',

  styleUrls: ['./flex-address-validator.component.scss']

})

export class FlexAddressValidatorComponent implements OnInit {
 
  addressList = [];

  currentEnteredAddress = {};

  addressForm: UntypedFormGroup;
 
  loading: boolean = false;

  denied: boolean = false;

  showAddressValidation: boolean = false;

  systemError: boolean = false;

  SelectedValue: number = 0;

  disableButton: boolean = true;

  isAddressValid: boolean = false;
 
  @Output() userInput: EventEmitter<any> = new EventEmitter<string | number>();
 
  constructor(

    private dialogRef: MatDialogRef<FlexAddressValidatorComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any,

    private router: Router,

    private translateService: TranslateService,

    private userService: UserService,

    private fb: UntypedFormBuilder,

    private addressValidationService: AddressValidationService,

    private payeeService: PayeeService,

    private taggingService: TaggingService

  ) {

    this.addressForm = this.fb.group({

      selection: [0, Validators.required]

    });

  }
 
  ngOnInit(): void {

    this.addressValidation();
 
    if (this.currentEnteredAddress) {

      this.taggingService.view({

        page_id: 'validate_address',

        step: 'validate_address',

        journey_step_number: '2'

      });

    }

  }
 
  addressValidation() {

    this.loading = true;

    this.addressValidationService.validateAddress({

      customerName: this.data.customerName,

      addressLine1: this.data.addressLine1,

      addressLine2: this.data.addressLine2,

      city: this.data.city,

      countrycode: 'US',

      zipcode: this.data.zipcode,

      state: this.data.state,

      companyName: this.data.companyName

    }).subscribe(

      data => {

        if (data !== undefined && data.status === 'Valid') {

          let hasMatch = false;

          this.isAddressValid = true;
 
          for (let a of data.candidateList) {

            if (

              a?.AddressLine[0]?.toLowerCase() == this.data.addressLine1.toString().toLowerCase() &&

              a?.PoliticalDivision2?.toLowerCase() == this.data.city.toString().toLowerCase() &&

              a?.PoliticalDivision1?.toLowerCase() == this.data.state.toString().toLowerCase() &&

              a.PostcodePrimaryLow == this.data.zipcode.toString() &&

              a.CountryCode == 'US'

            ) {

              hasMatch = true;

              break;

            }

          }
 
          if (hasMatch) {

            this.deniedPartyScreening();

          } else {

            this.addressList = data.candidateList;

            this.currentEnteredAddress = {

              address1: this.data.addressLine1,

              address2: this.data.addressLine2,

              city: this.data.city,

              state: this.data.state,

              zip: this.data.zipcode

            };

            this.showAddressValidation = true;

            this.loading = false;

          }

        } else {

          this.isAddressValid = false;

          this.deniedPartyScreening();

        }

      },

      error => {

        this.isAddressValid = false;

        this.deniedPartyScreening();

        this.loading = false;

      }

    );

  }
 
  deniedPartyScreening() {

    this.loading = true;

    this.denied = false;
 
    this.userService.deniedPartyCheckV2({

      company: 'Ups23',

      address: this.data.addressLine1,

      city: this.data.city,

      state: this.data.state,

      country: 'US',

      zip: this.data.zipcode

    }).subscribe(

      deniedPartyFound => {

        this.loading = false;

        if (deniedPartyFound != false) {

          this.showAddressValidation = false;

          this.denied = true;

        } else {

          this.showAddressValidation = true;

        }

      },

      error => {

        this.showAddressValidation = false;

        this.loading = false;

        this.systemError = true;

      }

    );

  }
 
  radioChange($event: any) {

    this.isAddressValid = true;

  }
 
  onSubmit() {
  if (this.currentEnteredAddress) {
    this.taggingService.link({
      link_name: 'Validate',
      link_page_id: 'validate_address'
    });
  }
 
  // If candidate addresses exist and user picked one from candidateList
  if (this.addressList && this.addressList.length > 0) {
    const selectedIndex = this.selection?.value ?? 0;
    const chosenAddress = this.addressList[selectedIndex] || this.addressList[0];
    sessionStorage.setItem("updatedVerifiedAddress", JSON.stringify(chosenAddress));
  } else {
    // Exact match or entered address confirmed
    const confirmedAddress = {
      AddressLine: [this.data.addressLine1],
      PoliticalDivision2: this.data.city,
      PoliticalDivision1: this.data.state,
      PostcodePrimaryLow: this.data.zipcode
    };
    sessionStorage.setItem("updatedVerifiedAddress", JSON.stringify(confirmedAddress));
  }
 
  // Close with success result '1'
  this.dialogRef.close('1');
}
 
  edit() {

    this.dialogRef.close('0');

  }
 
  get selection() { return this.addressForm.controls.selection; }

}
 